import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, HEADERS, TAGS } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button } from "react-bootstrap";

// const cookies = new Cookies();

class Tags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      show: false,
      confirm: false,
      name: "",
      id: "",
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + TAGS).then((res) => {
        console.log(res.data);
        this.setState({ tags: res.data });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        name: "",
        id: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      name: data.name,
      id: data.id,
      show: true,
    });
  };

  delete = (id) => {
    const { tags: tags } = this.state;
    axios.delete(BASE_URL + 'tag/' + id, HEADERS).then((res) => {
      const updatedData = tags.filter((tag) => tag.id !== id);
      this.setState({ tags: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { name, id } = this.state;
    let formData = new FormData();
    
    formData.append("name", name);


    if (id) {
      axios.put(BASE_URL + 'tag/' + id + "/", formData, HEADERS).then((res) => {
        const { tags: tags } = this.state;
        const index = tags.findIndex((tag) => tag.id === id);
        tags[index] = res.data;
        this.setState({ tags: tags, show: false });
      }).catch((err) => {
        console.log(err);
        console.log(err.message);
        console.log(err.response);
      });
    } else {
      axios.post(BASE_URL + TAGS, formData, HEADERS).then((res) => {
        this.setState({
          tags: [...this.state.tags, res.data],
          show: false,
        });
      }).catch((err) => {
        console.log(err);
        console.log(err.message);
        console.log(err.response);
      });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {
    const { show, confirm, name, id } = this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                <Form.Label>Наименование:</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={name}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-9">
          {permission && <AddButton onClick={() => this.showModal()} />}
          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
              {/* <th>Фото</th> */}
                <th>Id</th>
                <th>Таг</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {this.state.tags.map((tag) => (
                <tr key={tag.id}>
                  <td>{tag.id}</td>
                  <td>{tag.name}</td>
                  <td>
                    {permission && (
                      <EditButton onClick={() => this.get(tag)} />
                    )}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, tag.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Tags;
